module.exports = __webpack_public_path__ + "img/46.eec411ef.png";